export const CATALOG_ENTRIES = "CatalogEntries";
export const STATIC_CATALOG_ENTRIES = "StaticCatalogEntries";

export const PRODUCT_LISTING_CAROUSEL = "ProductListingCarousel";
export const SHOP_MENU_WRAPPER = "ShopMenuWrapper";

export const SWAGMAGIC_GLOBAL_CONTEXT_PROVIDER = "SwagmagicGlobalContextProvider";

export const BANNER = "Banner";
export const HERO = "Hero";
export const TESTIMONIAL = "Testimonial";
export const ACCORDION = "Accordion";
export const OTHER = "Other";
export const CATEGORY_BANNER = "CategoryBanner";
